<template>
  <section v-if="professionalReviews.length > 0">
    <div class="pb-4 text-center" v-if="hasThaiLanguage">
      <button class="btn btn-block btn-outline-dark px-4"
              @click="translateProfessionalReviews('translated')"
              v-if="displayType === 'original'">
        {{ $t('message.review.translate_to_english') }} <i class="fal fa-language fa-lg"></i>
      </button>

      <button class="btn btn-block btn-outline-dark px-4"
              @click="translateProfessionalReviews('original')"
              v-else>
        {{ $t('message.review.show_original_review') }} <i class="fal fa-language fa-lg"></i>
      </button>
    </div>
    <div class="customer-review-card" v-for="professionalReview, index in professionalReviews">
      <div>
        <div class="customer-photo-section">
          <img v-lazy="professionalReview.customer_picture"
               alt="customer picture"
               class="rounded-circle img-fluid img-reviewer p-0">
        </div>
        <div class="customer-review-body">
          <div class="reply-name">{{ professionalReview.customer_name | firstName }}</div>
          <p>
            <span v-html="$options.filters.ratingStar(professionalReview.rating)"></span>
            <span class="text-secondary" v-if="professionalReview.complete_cleaning_date">
              {{ professionalReview.complete_cleaning_date | prettyOnlyDate }}
            </span>
          </p>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="text-long mt-3" v-if="professionalReview.comment">
        <span v-if="professionalReview.display_type !== 'translated'">
            {{ professionalReview.comment }}
        </span>
        <span v-else>
            {{ professionalReview.translated_comment }}
        </span>
      </div>

      <div class="reply-customer-review mt-4"
           v-if="professionalReview.reply_comment">
        <div class="row">
          <div class="col-md-1 col-sm-1 col-2">
            <img v-lazy="professional.picture"
                 alt="provider picture"
                 width="32"
                 class="rounded-circle">
          </div>
          <div class="col-md-11 col-sm-11 col-10"
               :class="{'p-0': $mq.phone}">
            <div class="reply-name">{{ $t('message.review.response_from')}} {{ professional.name | firstName
              }}:
            </div>
            <div class="text-long mt-3">
                            <span v-if="professionalReview.display_type !== 'translated'">
                                {{ professionalReview.reply_comment }}
                            </span>
              <span v-else>
                                {{ professionalReview.translated_reply_comment }}
                            </span>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['professional', 'professionalReviews'],
    data () {
      return {
        translatedReviews: {},
        displayType: 'original'
      }
    },
    computed: {
      hasThaiLanguage () {
        let result = false
        if (this.professionalReviews) {
          const thaiString = /[ก-ฮ]+/
          for (let key in this.professionalReviews) {
            const professionalReview = this.professionalReviews[key]
            const review = `${professionalReview.comment} ${professionalReview.reply_comment}`
            result = thaiString.test(review)
            if (result) {
              return result
            }
          }
        }
        return result
      }
    },
    methods: {
      translateProfessionalReviews (displayType) {
        this.displayType = displayType
        this.$emit('changedDisplayType', displayType)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/review/ProfessionalReviews.vue